module.exports = __webpack_public_path__ + "img/bracelet.2477aa72.jpg";